
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.831 0h12.921v12.92h-1.999V2H31.831V0zM1 0h12.921v2H3v10.92H1V0zm41.753 30.83h2v12.921H31.83v-2h10.922v-10.92zM1 30.831h2v10.921h10.921v2H1v-12.92z"}})])
          )
        }
      }
    